import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M12.054 1.65a2.333 2.333 0 0 0-3.3 0l-3.77 3.77a1 1 0 0 0 0 1.414L6.869 8.72a1 1 0 0 0 1.414 0l2.764-2.764c.546.679.872 1.541.872 2.48a3.946 3.946 0 0 1-1.137 2.777v.016h-.015a3.946 3.946 0 0 1-2.806 1.166 3.946 3.946 0 0 1-2.781-1.142h.32a.75.75 0 0 0 0-1.5h-3a.75.75 0 1 0 0 1.5h.784a5.485 5.485 0 0 0 2.1 1.996H3a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-2.462a5.458 5.458 0 0 0 1.573-8.36 2.333 2.333 0 0 0-.057-3.24ZM7.576 7.307l3.418-3.418a.833.833 0 0 0-1.179-1.178L6.397 6.128l1.179 1.179Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  l
];
function n(r, d) {
  return e(), o("svg", a, [...c]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
